import templateStr from 'text!./advanced-filter-option.html';

export default [function () {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            customFilter: '=',
            advancedFilter: '=',
            filteredItemsCount: '@',
            optionChangeFunction: '&',
            showSubOptionsFunction: '&'
        },
        controller: ['$scope', function ($scope) {
            $scope.checkShowSubOptions = function () {
                return $scope.showSubOptionsFunction();
            };

            $scope.setAllOptions = function (subFilter, value) {
                subFilter.options.forEach(function (option) {
                    option.selected = value;
                });
                $scope.optionChangeFunction();
            };
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/AdvancedFilterOptionDirective/AdvancedFilterOption.js
// module id = 1727
// module chunks = 0